export default __webpack_public_path__ + "static/media/ConferenceIcon.200e3925.svg";